export default "__VITE_ASSET__D0f9qa8E__"